module.exports = __webpack_public_path__ + "img/il.688c40af.svg";